import {
    Box,
    Button,
    Menu,
    MenuButton,
    MenuList,
    Text,
    useDisclosure
} from '@chakra-ui/react'
import { useAuthContext } from 'contexts/auth'
import jwt_decode from 'jwt-decode'
import { AuthTokens } from 'models'
import React from 'react'
import { useNavigate } from 'react-router'
import formatter from 'utils/formatter'
import { CircleCustom } from './styles'

export const Profile: React.FC = () => {
    const { signout } = useAuthContext()
    const { currentUser } = useAuthContext()
    const navigate = useNavigate()
    const { onClose, isOpen, onOpen } = useDisclosure()
    const decodedIdToken =
        currentUser && (jwt_decode(currentUser.idToken) as AuthTokens)

    const handleNavigation = () => {
        onClose()
        navigate('/alterar-senha')
    }

    return (
        <Menu
            data-testid="profile"
            isOpen={isOpen}
            onClose={onClose}
            onOpen={onOpen}
        >
            <MenuButton
                data-testid="profile-box"
                as={Box}
                shadow={{ md: 'md' }}
                gap={2}
                rounded={6}
                cursor="pointer"
            >
                <Button
                    data-testid="profile-button"
                    colorScheme="off-white"
                    color="inherit"
                    size="md"
                    gap={2}
                >
                    <Text
                        data-testid="profile-name"
                        as="span"
                        display={{ base: 'none', sm: 'inline-block' }}
                    >
                        {decodedIdToken?.nome}
                    </Text>
                    <Box
                        data-testid="profile-avatar"
                        display="flex"
                        justifyContent="center"
                    >
                        <CircleCustom size={24}>
                            <Text fontWeight={500} lineHeight={6} fontSize={10}>
                                {formatter.transformInitals(
                                    decodedIdToken?.nome as string
                                )}
                            </Text>
                        </CircleCustom>
                    </Box>
                </Button>
            </MenuButton>
            <MenuList
                data-testid="profile-list"
                border={0}
                shadow="md"
                zIndex="dropdown"
            >
                <Box
                    data-testid="profile-list-content"
                    display="flex"
                    alignItems="center"
                    flexDirection="column"
                >
                    <Text
                        fontWeight="bolder"
                        mb={2}
                        data-testid="profile-title"
                    >
                        Configurações de conta
                    </Text>
                    <Box textAlign="center" data-testid="profile-body">
                        <Box
                            data-testid="profile-avatar"
                            display="flex"
                            justifyContent="center"
                            mb={4}
                        >
                            <CircleCustom size={36}>
                                <Text
                                    fontWeight={500}
                                    lineHeight={6}
                                    fontSize={14}
                                >
                                    {formatter.transformInitals(
                                        decodedIdToken?.nome as string
                                    )}
                                </Text>
                            </CircleCustom>
                        </Box>

                        <Text
                            data-testid="profile-name"
                            fontWeight="bolder"
                            fontSize="lg"
                            textOverflow="ellipsis"
                            overflow="hidden"
                            whiteSpace="nowrap"
                            mb={2}
                            maxW="200px"
                        >
                            {decodedIdToken?.nome}
                        </Text>
                        <Text data-testid="profile-email" fontSize="sm">
                            {decodedIdToken?.email}
                        </Text>
                        {/* <Text
                            data-testid="profile-codigo"
                            fontWeight="bolder"
                            fontSize="lg"
                        >
                            451
                        </Text> */}
                    </Box>
                    {/* <Button
                        data-testid="profile-settings"
                        colorScheme="primary"
                        variant="ghost"
                        w="full"
                    >
                        Configurações
                    </Button> */}

                    <Button
                        colorScheme="primary"
                        variant="ghost"
                        w="100%"
                        onClick={handleNavigation}
                    >
                        Alterar senha
                    </Button>

                    <Button
                        data-testid="profile-signout"
                        colorScheme="primary"
                        variant="ghost"
                        w="100%"
                        onClick={signout}
                    >
                        Sair
                    </Button>
                </Box>
            </MenuList>
        </Menu>
    )
}
